import About from "../../containers/description/description";

import "./about.css";

export default function Home() {
    return (
        <main className="home-page">
            <About />
        </main>
    );
}